export default "__VITE_ASSET__Nft1tchE__"